<template>
  <div class="data-upgrade">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>数据升级包维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form" method="post" enctype ="multipart/form-data">
        
        <el-form-item label="观测ID">
          <el-autocomplete
            class="inline-input"
            v-model="searchParams.obs_id"
            :fetch-suggestions="querySearch"
            :placeholder="`${$t('proposal.obs_id')}`"
            :trigger-on-focus="false"
            @select="handleSelect"
            clearable>
          </el-autocomplete>
          <!-- <el-input size="mini"  v-model="searchParams.obs_id"></el-input> -->
        </el-form-item>
        <el-form-item  label="数据级别">
          <el-select  size="mini" v-model="searchParams.level" style="width:200px;" filterable placeholder="1L/1.5L/2L..." clearable>
                  <el-option
                      v-for="item in datalevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="propinsert">新增</el-button>
        </el-form-item>

        <!-- <el-form-item>
          <el-button size="small"  @click="excelinsert">CSV格式导入</el-button>
        </el-form-item> -->

        <el-form-item>
          <el-button size="mini"  @click="excelinsert">CSV文件数据批量导入</el-button>
          <input
            class="upload-input"
            ref="file-input"
            type="file"
            name="source"
            @change="handleFileChange"
            accept=".csv">
        </el-form-item>
      </el-form>


      <el-table
        :data="list"
        style="width: 100%;"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          fixed
          prop="obs_id"
          label="观测号">        
        </el-table-column>
        <el-table-column
          prop="level"
          label="数据级别">
          <template slot-scope="{row}">
            <span :title="$t(`DataRelease.level.${row.level}`)">{{$t(`DataRelease.level.${row.level}`)}}</span>
          </template>>
        </el-table-column>
        <el-table-column
          prop="file_ver"
          label="数据版本">
        </el-table-column>
        <el-table-column
          prop="archive_time"
          label="数据归档日期">
        </el-table-column>
        <el-table-column
          prop="file_path"
          label="升级包文件"
          width="555">
        </el-table-column>
        
        <el-table-column
          fixed="right"
          width="150">
          <template slot="header" slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              v-if="false"
              type="text"
              size="small"
              @click="BatchEdit">
              批量修改
            </el-button>
          </template>
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="propEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small"
              @click="propDelete(scope.row.id)">
              删除
            </el-button>                   
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
      
      <DataUpgradeEditDialog
        :dialog-visible="DataUpgradeEditIsVisible"
        :dialog-data="currentEditData"
        @ok="confirmDataUpgradeEditDialog"
        @close="closeDataUpgradeEditDialog">
      </DataUpgradeEditDialog>

      <DataUpgradeInsertDialog
        :dialog-visible="DataUpgradeInsertIsVisible"
        :dialog-data="currentInsertData"
        @ok="confirmDataUpgradeInsertDialog"
        @close="closeDataUpgradeInsertDialog">
      </DataUpgradeInsertDialog>

      <DataUpgradeExcelInsertDialog
        :dialog-visible="DataUpgradeExcelInsertIsVisible"
        :dialog-data="currentExcelInsertData"
        @ok="confirmDataUpgradeExcelInsertDialog"
        @close="closeDataUpgradeExcelInsertDialog">
      </DataUpgradeExcelInsertDialog>


    </div>

  </div>
</template>

<script>
import {PropDataLevel} from '../common';
import DataUpgradeEditDialog from './DataUpgradeEditDialog.vue';
import DataUpgradeInsertDialog from './DataUpgradeInsertDialog.vue';
import DataUpgradeExcelInsertDialog from './DataUpgradeExcelInsertDialog.vue';

import axios from 'axios';

export default {
  name: 'DataUpgrade',
  components: {
    DataUpgradeEditDialog,
    DataUpgradeInsertDialog,
    DataUpgradeExcelInsertDialog,
  },
  data() {
    return {
      searchParams: {
        obs_id:'',
        level:'',
      },
      list: [],
      restaurants: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      datalevel:PropDataLevel,

      applyIsVisible: false,
      applyForm: {
        name: '',
        applyemail: '',
        applycop: '',
      },
      DataUpgradeExcelInsertIsVisible:false,
      DataUpgradeEditIsVisible:false,
      DataUpgradeInsertIsVisible:false,
      PropBatchEditIsVisible:false,
      currentExcelInsertData:null,
      currentInsertData: null,
      currentEditData:null,
      currentBatchEditData:null,
      multipleSelection:[],
    };
  },
  created() {
    this.getData();
    this.getobsiddata();
  },
  methods: {
    getData() {
      //@Todo 诡异的查询  在数据是否公开的条件，选择未公开时，搜出的结果有公开数据
      // console.log('isopenum',this.searchParams.isopenum);
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/DataUpgrade', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    getobsiddata(){
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
      axios.post('/iapi/getobslist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          // console.log('target-list',this.restaurants );
        }
      });
    },
    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
    },
    handleSelect() {
        // console.log(item);
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
        };
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    propinsert(){
      this.DataUpgradeInsertIsVisible = true ;
      this.currentInsertData = this.restaurants;
    },
    closeDataUpgradeInsertDialog(){
      this.DataUpgradeInsertIsVisible = false;
    },
    confirmDataUpgradeInsertDialog(data){
      this.closeDataUpgradeInsertDialog();
      const params = {
        obs_id : data.obs_id,
        level : data.level,
        file_ver : data.file_ver,
        file_path : data.file_path,
        archive_time : data.archive_time,


      }
      axios.post('/iapi/DataUpgradeinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增升级包数据成功！');
        }
      });
      this.getData();  
    },
    propEdit(dataId){
      this.DataUpgradeEditIsVisible = true;
      this.currentEditData = dataId;
    },
    closeDataUpgradeEditDialog(){
      this.DataUpgradeEditIsVisible = false;
    },
    closeDataUpgradeExcelInsertDialog(){
      this.DataUpgradeExcelInsertIsVisible = false;
      this.currentExcelInsertData = null;
    },
    confirmDataUpgradeExcelInsertDialog(data){
      this.closeDataUpgradeExcelInsertDialog();
      const params = {
        data: data,
      };
      axios.post('/iapi/insertDataUpgradeExcel', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('CSV数据导入成功！');
        }
      });
      this.getData();
      // console.log('data',data);
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
      // console.log('多选内容',this.multipleSelection);
    },
    confirmDataUpgradeEditDialog(data){
      this.closeDataUpgradeEditDialog();
      const params = {
        id : data.id,
        obs_id : data.obs_id,
        level : data.level,
        archive_time : data.archive_time,
        file_ver : data.file_ver,
        file_path : data.file_path,
       
      }
      axios.post('/iapi/DataUpgradeedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑升级包数据成功！');
        }
      });
      this.getData();  
    },
    propDelete(DataID){
      const params = {
        id: DataID,
      };
      axios.post('/iapi/DataUpgradedelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除升级包数据成功！');
        }
      });
      this.getData();
    },

    excelinsert(){
      let inputDOM = document.querySelector('.upload-input');
      inputDOM.click();
    },

    handleFileChange() {
      let inputDOM = this.$refs['file-input'];
      if (inputDOM.files.length) {
        let file = inputDOM.files[0];
        let formData=new FormData();
        formData.append('source', file);
        axios({
          url: '/iapi/DataUpgradeExcel',
          data: formData,
          method: 'post',
          headers:{
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => {
          if (res.data.errcode === 0) {
            this.currentExcelInsertData = res.data.data;
            this.DataUpgradeExcelInsertIsVisible = true;
          } else {
            this.$message.error('上传文件失败1');
          }
          inputDOM.value = '';
        }).catch((err) => {
          // console.log('err', err);
          this.$message.error('上传文件失败2',err);
        });
      }
    },
  },
};
</script>

<style scoped>
.data-upgrade {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
.upload-input {
  display: none;
}
</style>